module.exports = __webpack_public_path__ + "img/banner-product-update.f3636d28.png";